/**
 * Imports for every project using 1stlog-ui.
 */

import dayjs from 'dayjs'
import duration from 'dayjs/plugin/duration'
import * as moment from 'moment'
import momentDurationFormatSetup from 'moment-duration-format'

// console.log(typeof moment.duration.fn.format)
// packages
import '../node_modules/react-day-picker/lib/style.css'
import '../node_modules/react-image-lightbox/src/style.css'
import 'react-grid-layout/css/styles.css'
import 'react-bootstrap-typeahead/css/Typeahead.css'
// ol
import 'ol/ol.css'
// ol legacy
import './styles/openlayers.css'
// bootstrap overwrite
import './styles/bootstrap-overwrite.css'
// fontcustom import
import './styles/fontcustom.css'
// semantic ui
import 'semantic-ui-css/components/popup.min.css'
import 'semantic-ui-css/components/segment.min.css'
import 'semantic-ui-css/components/label.min.css'
import 'semantic-ui-css/components/menu.min.css'
import 'semantic-ui-css/components/tab.min.css'
import 'semantic-ui-css/components/grid.min.css'
import 'semantic-ui-css/components/divider.min.css'
import 'semantic-ui-css/components/message.min.css'
import 'semantic-ui-css/components/modal.min.css'
import 'semantic-ui-css/components/dimmer.min.css'
import 'semantic-ui-css/components/transition.min.css'
import 'semantic-ui-css/components/container.min.css'
import 'semantic-ui-css/components/placeholder.min.css'
import 'semantic-ui-css/components/step.min.css'
import 'semantic-ui-css/components/progress.min.css'
import 'semantic-ui-css/components/checkbox.min.css'
// import "semantic-ui-css/components/icon.min.css"
// semantic overwrite
import './styles/semantic-ui-overwrite.css'
import './styles/folder-tree-overwrite.css'
// custom
import './styles/main.css'
import './styles/ios-scroll-bug.css'
import '@1stLog-engineering/file-uploads/dist/style.css'

dayjs.extend(duration)

momentDurationFormatSetup(moment)
